import { defineMessages } from "react-intl";

export default defineMessages({
  scoutTitle: {
    id: "ScoutCard.soutTitle",
    defaultMessage: "Scouting",
  },
});
